export type CommsChannelSlug = 'EMAIL' | 'SMS' | 'PHONE' | 'WHATSAPP';

export const CommsChannelSlug = {
  EMAIL: 'EMAIL' as CommsChannelSlug,
  SMS: 'SMS' as CommsChannelSlug,
  PHONE: 'PHONE' as CommsChannelSlug,
  WHATSAPP: 'WHATSAPP' as CommsChannelSlug,
};
